/* ==========================================================================
   CLARITY HEALTH CO — CAROUSEL  (Phase 5)
   Minimal, accessible controller for the Featured Products carousel. The track
   is a native scroll-snap container (touch/trackpad already work); this adds
   prev/next buttons, disabled-state sync, and hides controls when everything
   fits. Honours prefers-reduced-motion.
   ========================================================================== */
(function () {
  class ClarityCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      this.prev && this.prev.addEventListener('click', () => this.page(-1));
      this.next && this.next.addEventListener('click', () => this.page(1));

      // Arrow keys when the track itself is focused
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.page(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); this.page(-1); }
      });

      this._onScroll = () => this.update();
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll);
      // Re-measure once images/fonts settle
      requestAnimationFrame(() => this.update());
      setTimeout(() => this.update(), 400);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onScroll);
    }

    step() {
      const cell = this.track.querySelector('.clarity-feat__cell');
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return cell ? cell.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
    }

    page(dir) {
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const step = this.step();
      const max = this.track.scrollWidth - this.track.clientWidth;
      // Absolute, snap-aligned target avoids drift/fighting scroll-snap.
      let target = Math.round((this.track.scrollLeft + dir * step) / step) * step;
      target = Math.max(0, Math.min(max, target));
      this.track.scrollTo({ left: target, behavior });
    }

    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const scrollable = max > 2;
      this.toggleAttribute('data-static', !scrollable);
      if (this.prev) this.prev.disabled = t.scrollLeft <= 1;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 1;
    }
  }

  if (!customElements.get('clarity-carousel')) customElements.define('clarity-carousel', ClarityCarousel);
})();
